import * as actions from "./usersMeGetActions";
import { UI_POPUPS_POST_REQUEST_SUCCESS } from "store/api/uiPopupsPost/uiPopupsPostActions";

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [actions.USERS_ME_GET_REQUEST]: (state, action) => ({
    ...state,
    loading: true,
    loaded: false,
    error: null,
    data: state.data,
  }),
  [actions.USERS_ME_GET_REQUEST_SUCCESS]: (state, action) => ({
    ...state,
    loading: false,
    loaded: true,
    error: null,
    data: action.data,
  }),
  [actions.USERS_ME_GET_REQUEST_FAILURE]: (state, action) => ({
    ...state,
    loading: false,
    loaded: false,
    error: action.error,
    data: null,
  }),
  [actions.USERS_ME_GET_RESET]: (state, action) => initialState,

  [UI_POPUPS_POST_REQUEST_SUCCESS]: (state, { data }) => ({
    ...state,
    data: state.data
      ? { ...state.data, user: { ...data, role: state.data.user.role } }
      : null,
  }),
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  loaded: false,
  loading: false,
  error: null,
  data: null,
};

export default function usersMeGetReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
